import '../../index.css'

const Marquee = () => {
    return (
        <>
            <marquee >
                <ul className=" marquee-list">
                    <li>
                        <img src="https://maorif.tj/images/4.png"></img>
                    </li>
                    <li>
                        <img src="https://maorif.tj/images/3.png"></img>
                    </li>
                    <li>
                        <img src="https://maorif.tj/images/5.png"></img>
                    </li>
                    <li>
                        <img src="https://maorif.tj/images/6.png"></img>
                    </li>
                    <li>
                        <img src="https://maorif.tj/images/7.png"></img>
                    </li>
                    <li>
                        <img src="https://maorif.tj/images/8.png"></img>
                    </li>
                    <li>
                        <img src="https://maorif.tj/images/9.png"></img>
                    </li>
                    <li>
                        <img src="https://maorif.tj/images/10.png"></img>
                    </li>
                </ul>
            </marquee>
        </>
    )
}
export default Marquee;